import * as React from 'react';

import Tooltip from '@mui/material/Tooltip';

export default function IconToolTip(props) {
    const { title, titleClassName = "text-font09", onClick = () => { }, placement, style = {} } = props;
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <Tooltip placement={placement} onClick={onClick} open={open} onClose={handleClose} onOpen={handleOpen} title={<p onClick={(e) => { e.stopPropagation() }} className={` ${titleClassName}`} style={style}>{title}</p>}>
            {props.children}
        </Tooltip>
    );
}
